import React from 'react';
import './btnStyle.scss';

const PrimaryRoundButton = ({ label, onClick, disabled, iconClass }) => {
    return (
        <button
          className="btn btn-round-primary col-md-12"
          onClick={onClick}
          disabled={disabled}
        >
          <div className="btn-content d-flex align-items-center w-100">
            <span className=" col-md-10">{label}</span>
            {iconClass && <i className={`bi ${iconClass} btn-icon ms-2`}></i>}
          </div>
        </button>
      );
};

export default PrimaryRoundButton;